import { SomethingWentWrong } from '@zoomit/web-kit';

export const SthWentWrong = () => <SomethingWentWrong />;
